import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Haley Halcyon
 * id A64D06DE-1EE4-400F-9E17-2B5D319475A3
 * name door-open
 * version: 2.1.19
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/door-open.svg
 * tags
 * - Home Automation 
 */
export const DoorOpenIcon = createSvgIcon(<><path d="M12,3C10.89,3 10,3.89 10,5H3V19H2V21H22V19H21V5C21,3.89 20.11,3 19,3H12M12,5H19V19H12V5M5,11H7V13H5V11Z" /></>, 'DoorOpenIcon');
export default DoorOpenIcon